import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { SessionProvider } from './state/SessionContext';
import { ToastProvider } from './components/Toast/ToastContext';
import './styles/global.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Failed to find root element for SPA');
}

const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <SessionProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </SessionProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
